import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import EMTable from './EMTable';
import __t from '../../locales';
import { toDateObjectFromJson, toDateString } from '../../_helpers/dateConvert';

export const SpecialDaysTable = (props) => {
    const rowData = [
        {
            id: 'dayDate', align: 'center', disablePadding: false, label: __t('date'), formatter: function (value) {
                return toDateString(toDateObjectFromJson(value))
            }
        },
    ];

    return (
        <EMTable
            tableTitle={`${__t('special_days')}`}
            dataSource={props.values}
            rows={rowData}
            onAdd={props.onAdd}
            onView={props.onView}
            onEdit={props.onEdit}
            onEditCondition={props.onEditCondition}
            onDelete={props.onDelete}
            onDeleteCondition={props.onDeleteCondition}
        />
    );
};

SpecialDaysTable.propTypes = {
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    onEditCondition: PropTypes.func,
    onDelete: PropTypes.func,
    onDeleteCondition: PropTypes.func,
    values: PropTypes.array
}